import React from "react";
import {CaptionStepComponent, FullCaptionComponent} from "../../../../../app/components/caption/CaptionComponent";
import {CodeComponent} from "../../../../../app/components/code/CodeComponent";

export function HashSetRemoveNeg7FullCaption() {
    return (<FullCaptionComponent title="VALUE: -7">
        <HashSetRemoveNeg71/>
        <HashSetRemoveNeg72/>
        <HashSetRemoveNeg73/>
        <HashSetRemoveNeg74/>
    </FullCaptionComponent>)
}

export function HashSetRemoveNeg71() {
    const generateHashFunction = "fun generateHash(value: Int): Int {return value % arraySize}"
    return (<CaptionStepComponent title={<h6>1. Generate <CodeComponent
        className="codeHash">HASH</CodeComponent>. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Assuming our hash function is <CodeComponent>{generateHashFunction}</CodeComponent>, if we input -7, we
            output a <CodeComponent className="codeHash">HASH</CodeComponent> of 1.</p>
    </CaptionStepComponent>)
}

export function HashSetRemoveNeg72() {
    return (<CaptionStepComponent title={<h6>2. Find sub-collection at the <CodeComponent
        className="codeHash">HASH</CodeComponent> index. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Because our <CodeComponent className="codeHash">HASH</CodeComponent> is 1, we now want to find the
            sub-collection at index 1 of our array.</p>
    </CaptionStepComponent>)
}

export function HashSetRemoveNeg73() {
    return (<CaptionStepComponent title={<h6>3. Iterate over our sub-collection until we found the <CodeComponent
        className="codeValue">VALUE</CodeComponent> we want to
        remove. <CodeComponent><s>O(n)</s></CodeComponent><CodeComponent>O(1)</CodeComponent></h6>}>
        <p>At <CodeComponent className="codeHash">HASH</CodeComponent> index 1, we only have a single item. Here, we see
            we still have our average case of only one <CodeComponent
                className="codeValue">VALUE</CodeComponent> located in our sub-collection, but we see that
            the <CodeComponent className="codeValue">VALUE</CodeComponent> we want to remove isn't equal to
            the <CodeComponent className="codeValue">VALUE</CodeComponent> we have in our HashSet.</p>
    </CaptionStepComponent>)
}

export function HashSetRemoveNeg74() {
    return (<CaptionStepComponent
        title={<h6>4. Remove <CodeComponent className="codeValue">VALUE</CodeComponent> from our
            sub-collection. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>In this case, we would return early, as the <CodeComponent className="codeValue">VALUE</CodeComponent> we
            want to remove does not exist in the HashSet. Our HashSet wouldn't change.</p>
    </CaptionStepComponent>)
}
